import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewTransactionListingComponent } from '../new-transaction-listing/new-transaction-listing.component';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { GoogleReviewModalComponent } from '../google-review-modal/google-review-modal.component';
import { FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-new-sub-admins-subscription',
  templateUrl: './new-sub-admins.component.html',
  styleUrls: ['./new-sub-admins.component.scss'],
})
export class NewSubAdminsTransactions implements OnInit {
  transactions: any;
  total_txn: number = 0;
  tab_type = 1;
  userDropdown: { name: string; }[];
  slotTransactions: any;
  
  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private local: LocalServiceService
  ) {}

  ngOnInit(): void { 
    this.vip_sub_transactions(1);
    this.userDropdownData();
  }

  userDropdownData() {
    this.userDropdown = [
      { name: 'Joel' },
      { name: 'Company' }
    ]
  }

  vip_sub_transactions(show) {
    this.tab_type = show;
    this.auth.vip_transactions(show).subscribe((response: any) => {
      this.transactions = response.body.transactions;
      this.total_txn = response.body.available;
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }

  slot_transactions() {
    this.tab_type = 3;
    this.auth.slotTransactions().subscribe((response: any) => {
      this.slotTransactions = response.body;
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }

  onChangeUser(event, id) {
    let formData = new FormData();
    formData.append('viptoken_txn_id', id);
    formData.append('selectedUser', event.target.value);

    this.auth.updateTransactionUser(formData).subscribe((response: any) => {
      this.toastr.success(response.message);
    }, (error) => {
      if (error.status == 400) {
        this.toastr.error(error.error.message)
      }
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }
}
